module.exports = "import React from 'react'\n\nconst Buttons = ({sc}) => (\n  <ul>\n    <li> <button className=\"btn btn-primary\" onClick={(e) => {sc.gen('plug-in')}}> Plug In </button> </li>\n    <li> <button className=\"btn btn-secondary\" onClick={(e) => {sc.gen('start')}}> Start </button> </li>\n    <li> <button className=\"btn btn-success\" onClick={(e) => {sc.gen('stop')}}> Stop </button> </li>\n    <li> <button className=\"btn btn-info\" onClick={(e) => {sc.gen('unplug')}}> Unplug </button> </li>\n  </ul>\n);\n\nexport default Buttons \n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/microwave-example/buttons.js?txt
// module id = 888
// module chunks = 240162396545425